module.exports = __webpack_public_path__ + "img/selected.472fac02.svg";